import React from 'react'
import Header from '../Menpages/Header/Main'
import Footer from '../Menhome/Footer'
import Bredcom from '../MenTeam/Bredcom'
import Work from '../Mencontact/Work'
import Slider from '../Menpages/GlobleSlider/Main'

function Main() {
  return (
    <>
        <div className="page-wrapper">
            <Header/>
            <Bredcom title={"Home"} head={"Contact Us"} sbtitle={"Contact Us"}/>
            <Work/>
            <Slider/>
            <Footer/>
        </div>
    </>
  )
}

export default Main